/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbRespLayout_viewer$ref = any;
type detectPageExistsAndRedirect_viewer$ref = any;
type getDomainLinksSb_viewer$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type sbRespRootQueryVariables = {
    readonly userId?: string | null;
    readonly fetchUser: boolean;
    readonly uriRef?: string | null;
    readonly first: number;
    readonly page: number;
    readonly localeOrigin?: string | null;
    readonly isTrade: boolean;
    readonly showSeller: boolean;
    readonly followSearchPages?: ReadonlyArray<string | null> | null;
    readonly followSearchTypes?: ReadonlyArray<types | null> | null;
    readonly contentModuleId?: string | null;
    readonly eligibleAbTest?: string | null;
    readonly userZipCode?: string | null;
    readonly isClient: boolean;
    readonly fetchSb: boolean;
    readonly disableForceFacet?: boolean | null;
};
export type sbRespRootQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": getDomainLinksSb_viewer$ref & SbRespLayout_viewer$ref & detectPageExistsAndRedirect_viewer$ref;
    } | null;
};
export type sbRespRootQuery = {
    readonly response: sbRespRootQueryResponse;
    readonly variables: sbRespRootQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchUser",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "uriRef",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "localeOrigin",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showSeller",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "followSearchPages",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "followSearchTypes",
            "type": "[types]",
            "defaultValue": [
                "SEARCH"
            ]
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "contentModuleId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "eligibleAbTest",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userZipCode",
            "type": "String",
            "defaultValue": "0"
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isClient",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchSb",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "disableForceFacet",
            "type": "Boolean",
            "defaultValue": false
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "uriRef",
        "variableName": "uriRef"
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "rank",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "urlLabel",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "Variable",
            "name": "contentModuleId",
            "variableName": "contentModuleId"
        } as any)
    ], v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v9 = [
        (v4 /*: any*/)
    ], v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v12 = [
        ({
            "kind": "Literal",
            "name": "limit",
            "value": 1
        } as any)
    ], v13 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "webPath",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "count",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hexCode",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedFilterName",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "Variable",
        "name": "isTrade",
        "variableName": "isTrade"
    } as any), v19 = [
        (v18 /*: any*/)
    ], v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "photo",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "link",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "linkText",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "image",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "key",
        "args": null,
        "storageKey": null
    } as any), v27 = [
        (v5 /*: any*/),
        (v4 /*: any*/)
    ], v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryPath",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "browseUrl",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryCode",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contemporaryTrackingString",
        "args": null,
        "storageKey": null
    } as any), v33 = [
        (v28 /*: any*/),
        (v14 /*: any*/)
    ], v34 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "seller",
        "storageKey": null,
        "args": null,
        "concreteType": "Seller",
        "plural": false,
        "selections": (v33 /*: any*/)
    } as any), v35 = [
        (v18 /*: any*/),
        ({
            "kind": "Literal",
            "name": "page",
            "value": "searchAndBrowse"
        } as any)
    ], v36 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v37 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v36 /*: any*/),
            (v25 /*: any*/)
        ]
    } as any), v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v39 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v40 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "paragraphs",
        "storageKey": null,
        "args": null,
        "concreteType": "QuickViewParagraph",
        "plural": true,
        "selections": [
            (v26 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "text",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": "mobileText",
                "name": "text",
                "args": (v39 /*: any*/),
                "storageKey": "text(formatType:\"MOBILE\")"
            }
        ]
    } as any), v41 = ({
        "kind": "ScalarField",
        "alias": "mobileTitle",
        "name": "title",
        "args": (v39 /*: any*/),
        "storageKey": "title(formatType:\"MOBILE\")"
    } as any), v42 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustomizable",
        "args": null,
        "storageKey": null
    } as any), v43 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isMultiSku",
        "args": null,
        "storageKey": null
    } as any), v44 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedPdpUrl",
        "args": null,
        "storageKey": null
    } as any), v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vertical",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayPrice",
        "storageKey": null,
        "args": (v35 /*: any*/),
        "concreteType": "ItemDisplayPriceType",
        "plural": true,
        "selections": [
            (v37 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityDisplay",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "percentageOff",
                "args": null,
                "storageKey": null
            },
            (v38 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceLabel",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceVariability",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v47 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "lowestShipmentQuote",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "complimentaryShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "totalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                            (v25 /*: any*/),
                            (v36 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "serviceMethod",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                    },
                    (v14 /*: any*/)
                ]
            },
            (v14 /*: any*/)
        ]
    } as any), v48 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "classification",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemClassification",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "creationDate",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v49 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "creators",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCreator",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "attribution",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creator",
                "storageKey": null,
                "args": null,
                "concreteType": "Creator",
                "plural": false,
                "selections": [
                    (v4 /*: any*/),
                    (v14 /*: any*/)
                ]
            },
            (v14 /*: any*/)
        ]
    } as any), v50 = ({
        "kind": "LinkedField",
        "alias": "productPhotos",
        "name": "photos",
        "storageKey": "photos(limit:1)",
        "args": (v12 /*: any*/),
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "placeholder",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "smallPath",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "masterOrZoomPath",
                "args": null,
                "storageKey": null
            },
            (v13 /*: any*/),
            (v14 /*: any*/)
        ]
    } as any), v51 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
    } as any), v52 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "measurement",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemMeasurement",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "dimensions",
                "name": "display",
                "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "addLabel",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "fields",
                        "value": [
                            "height",
                            "width",
                            "depth",
                            "diameter"
                        ]
                    },
                    {
                        "kind": "Literal",
                        "name": "separator",
                        "value": " "
                    }
                ],
                "concreteType": "ItemDisplayMeasurementType",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "unit",
                        "args": null,
                        "storageKey": null
                    },
                    (v51 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "size",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSize",
                "plural": false,
                "selections": [
                    (v51 /*: any*/)
                ]
            }
        ]
    } as any), v53 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "sellerProfile",
        "storageKey": null,
        "args": null,
        "concreteType": "SellerProfile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "company",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v54 = [
        ({
            "kind": "Literal",
            "name": "featureName",
            "value": "NON_MVP_SEARCH_BROWSE"
        } as any)
    ], v55 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v56 = ({
        "kind": "Variable",
        "name": "zipCode",
        "variableName": "userZipCode"
    } as any), v57 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "iconUri",
        "args": null,
        "storageKey": null
    } as any), v58 = [
        ({
            "kind": "Literal",
            "name": "address",
            "value": {
                "country": "us"
            }
        } as any),
        ({
            "kind": "Literal",
            "name": "regionBoundaryTypes",
            "value": [
                "METROPOLITAN",
                "DISTRICT",
                "DOMESTIC"
            ]
        } as any),
        ({
            "kind": "Literal",
            "name": "regionType",
            "value": "ITEM_LOCATION"
        } as any)
    ], v59 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v60 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "daysRelativeToExpiration",
        "args": [
            {
                "kind": "Literal",
                "name": "truncate",
                "value": false
            }
        ],
        "storageKey": "daysRelativeToExpiration(truncate:false)"
    } as any), v61 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "benefit",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "sbRespRootQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "getDomainLinksSb_viewer",
                            "args": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "SbRespLayout_viewer",
                            "args": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "detectPageExistsAndRedirect_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "sbRespRootQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "itemSearch",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "disableForceFacet",
                                    "variableName": "disableForceFacet"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "eligibleAbTest",
                                    "variableName": "eligibleAbTest"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "localeOrigin",
                                    "variableName": "localeOrigin"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "page",
                                    "variableName": "page"
                                },
                                (v1 /*: any*/)
                            ],
                            "concreteType": "ItemSearchQueryConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pageType",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "languageAnnotations",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "LanguageAnnotations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "available",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "href",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "hrefLang",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "displayUriRef",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "vanityUriRef",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isForceFacetSearch",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "spellCheck",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SpellcheckSuggestions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "redirect",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SpellcheckSuggestionsRedirected",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "redirectTo",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "semanticSearch",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SemanticSearchType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "originalSearchTerm",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "appliedFilters",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SearchBrowseParsedParam",
                                    "plural": true,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "values",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseParsedParamValue",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v5 /*: any*/),
                                                (v6 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "topCategoryL1",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "totalResults",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "browseContentModule",
                                    "storageKey": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v8 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "moduleType",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "sort",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SortType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "currentOption",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseSortCurrentOption",
                                            "plural": false,
                                            "selections": [
                                                (v5 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "categoryTiles",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SearchBrowseCategoryTiles",
                                    "plural": true,
                                    "selections": (v9 /*: any*/)
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "meta",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MetaData",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canonical",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "prev",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "disableIndexing",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v10 /*: any*/),
                                        (v11 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "next",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "microdata",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ItemSearchQueryEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemSearchResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "photos",
                                                            "storageKey": "photos(limit:1)",
                                                            "args": (v12 /*: any*/),
                                                            "concreteType": "ItemPhoto",
                                                            "plural": true,
                                                            "selections": [
                                                                (v13 /*: any*/),
                                                                (v14 /*: any*/)
                                                            ]
                                                        },
                                                        (v14 /*: any*/)
                                                    ]
                                                },
                                                (v14 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "pageExists",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "redirect",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "redirectType",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "location",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "fetchSb",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "spellCheck",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SpellcheckSuggestions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "newQuery",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "redirect",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SpellcheckSuggestionsRedirected",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "redirectFrom",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "suggestions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SpellcheckSuggestionsValues",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v15 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "uri",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "oldQuery",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canShowSearchVariantBurgundy",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "semanticSearch",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SemanticSearchType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "forceSearchUri",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canFollowSearch",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "meta",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "MetaData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "header",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "appliedFilters",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseParsedParam",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "values",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseParsedParamValue",
                                                    "plural": true,
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v15 /*: any*/)
                                                    ]
                                                },
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "canBeDismissed",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "breadcrumbs",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseBreadcrumbs",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "path",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "priceTiles",
                                            "storageKey": null,
                                            "args": (v19 /*: any*/),
                                            "concreteType": "SearchBrowsePriceTile",
                                            "plural": true,
                                            "selections": (v9 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "browseContentModule",
                                            "storageKey": null,
                                            "args": (v7 /*: any*/),
                                            "concreteType": null,
                                            "plural": false,
                                            "selections": [
                                                (v8 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModuleRegular",
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v20 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModuleBanner",
                                                    "selections": [
                                                        (v20 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "subtitle",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v11 /*: any*/),
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModulePromo",
                                                    "selections": [
                                                        (v20 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pillText",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "headline",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "subtext",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v21 /*: any*/),
                                                        (v22 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "categoryTiles",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseCategoryTiles",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "itemId",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "masterImage",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayMaxNumberOfPages",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "filters",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseFilter",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "values",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseFilterValue",
                                                    "plural": true,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        (v5 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "linkReference",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "linkable",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v25 /*: any*/),
                                                        (v15 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "stats",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "stats",
                                                            "plural": true,
                                                            "selections": [
                                                                (v26 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "values",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        (v6 /*: any*/),
                                                        (v16 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "totalCount",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isAttributePage",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "sort",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SortType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "options",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseSortAvailableOptions",
                                                    "plural": true,
                                                    "selections": (v27 /*: any*/)
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "searchTerm",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemSearchQueryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ItemSearchResult",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "item",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                (v28 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v29 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v34 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": "displayPriceTracking",
                                                                    "name": "displayPrice",
                                                                    "storageKey": null,
                                                                    "args": (v35 /*: any*/),
                                                                    "concreteType": "ItemDisplayPriceType",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v37 /*: any*/),
                                                                        (v38 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "quickViewDisplay",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "QuickViewDisplayType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v40 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v41 /*: any*/)
                                                                    ]
                                                                },
                                                                (v42 /*: any*/),
                                                                (v43 /*: any*/),
                                                                (v44 /*: any*/),
                                                                (v45 /*: any*/),
                                                                (v46 /*: any*/),
                                                                (v47 /*: any*/),
                                                                (v48 /*: any*/),
                                                                (v49 /*: any*/),
                                                                (v50 /*: any*/),
                                                                (v52 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "displayInfo",
                                                                    "storageKey": null,
                                                                    "args": (v35 /*: any*/),
                                                                    "concreteType": "ItemDisplayInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "ctas",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "CTADisplay",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "showMakeOffer",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "showSeller",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "seller",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Seller",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v53 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "isTrade",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "lowestShipmentQuote",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ShipmentQuote",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "isFreeToBuyer",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": "relatedItems",
                                            "name": "thinBrowseRelatedItems",
                                            "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 12
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "seller",
                                                    "value": "INCLUDE"
                                                }
                                            ],
                                            "concreteType": "itemSearchMoreLikeThisConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "itemSearchMoreLikeThisEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                (v42 /*: any*/),
                                                                (v43 /*: any*/),
                                                                (v28 /*: any*/),
                                                                (v44 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v45 /*: any*/),
                                                                (v46 /*: any*/),
                                                                (v47 /*: any*/),
                                                                (v48 /*: any*/),
                                                                (v49 /*: any*/),
                                                                (v50 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "quickViewDisplay",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "QuickViewDisplayType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v10 /*: any*/),
                                                                        (v41 /*: any*/),
                                                                        (v40 /*: any*/)
                                                                    ]
                                                                },
                                                                (v52 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "showSeller",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "seller",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Seller",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v28 /*: any*/),
                                                                                (v53 /*: any*/),
                                                                                (v14 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "internalBuyLinks",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "InternalBuyLinkType",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "anchorText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v23 /*: any*/),
                                                (v14 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "condition": "isTrade",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "priceTiles",
                                                    "storageKey": null,
                                                    "args": (v19 /*: any*/),
                                                    "concreteType": "SearchBrowsePriceTile",
                                                    "plural": true,
                                                    "selections": [
                                                        (v25 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v23 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "facets",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseFacets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "location",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "FacetValueType",
                                                            "plural": true,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "label",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v14 /*: any*/)
                                                            ]
                                                        },
                                                        (v14 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "enableSearchLandingPage",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "enableSearchLandingPage"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"enableSearchLandingPage\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isBillboardAdEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isThinItemSearchEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isMoreWaysToBrowseEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isFollowSearchEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isShopByRoomEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "SHOP_BY_ROOM"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSbRespFollowSearchEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "disableFollowSearchStickyBanner",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "disableFollowSearchStickyBanner"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"disableFollowSearchStickyBanner\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isContentModuleEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "BROWSE_CONTENT_MODULES"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSkyscraperAdEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSbSharedRefineMenuSearchWithinEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isMatchedSetsEnabled",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "enableMatchedSetsFacet"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSearchWithinFilterEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "REFINE_MENU_SEARCH"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isDeliveryOptionsDisabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
                        },
                        {
                            "kind": "LinkedField",
                            "alias": "locations",
                            "name": "facetSearch",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "facetName",
                                    "value": "location"
                                },
                                (v55 /*: any*/),
                                {
                                    "kind": "Literal",
                                    "name": "page",
                                    "value": 1
                                },
                                (v1 /*: any*/),
                                (v56 /*: any*/)
                            ],
                            "concreteType": "FacetsQueryConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FacetsQueryEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FilterValueType",
                                            "plural": false,
                                            "selections": [
                                                (v15 /*: any*/),
                                                (v4 /*: any*/),
                                                (v5 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isSeoQuicklookEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "SEO_QUICKLOOK"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isTileAdEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isFavoritesEnabled",
                            "name": "isEnabledByLocale",
                            "args": (v54 /*: any*/),
                            "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isVisuallySimilarEnabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "VISUALLY_SIMILAR"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "contactInfo",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ContactInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "phoneNumbers",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "support",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "tradeSupport",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "formatType",
                                                    "value": "INTERNATIONAL"
                                                }
                                            ],
                                            "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                                        }
                                    ]
                                }
                            ]
                        },
                        (v8 /*: any*/),
                        (v14 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isTrade",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tradeProgramsQuery",
                                    "storageKey": "tradeProgramsQuery(programCodes:[\"BRONZE\"])",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "programCodes",
                                            "value": [
                                                "BRONZE"
                                            ]
                                        }
                                    ],
                                    "concreteType": "LoyaltyProgram",
                                    "plural": true,
                                    "selections": [
                                        (v57 /*: any*/),
                                        (v14 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSbTradeFreeShippingTestDisabled",
                                    "name": "isEnabled",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "disableSbTradeFreeShippingTest"
                                        }
                                    ],
                                    "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regions",
                                    "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                                    "args": (v58 /*: any*/),
                                    "concreteType": "Region",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "regionName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v5 /*: any*/),
                                        (v14 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isTrade",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": "parentPrograms",
                                            "name": "tradeProgramsQuery",
                                            "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "programCodes",
                                                    "value": [
                                                        "MEMBER",
                                                        "BRONZE",
                                                        "SILVER",
                                                        "GOLD",
                                                        "PLATINUM"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "LoyaltyProgram",
                                            "plural": true,
                                            "selections": [
                                                (v6 /*: any*/),
                                                (v4 /*: any*/),
                                                (v57 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "maxPoints",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "minPoints",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v14 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "regions",
                                            "storageKey": "regions(address:{\"country\":\"us\"},regionBoundaryTypes:[\"METROPOLITAN\",\"DISTRICT\",\"DOMESTIC\"],regionType:\"ITEM_LOCATION\")",
                                            "args": (v58 /*: any*/),
                                            "concreteType": "Region",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "regionBoundary",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "RegionBoundary",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "type",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "RegionBoundaryType",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isClient",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "shippingFilters",
                                            "storageKey": null,
                                            "args": [
                                                (v1 /*: any*/),
                                                (v56 /*: any*/)
                                            ],
                                            "concreteType": "ShippingFilterType",
                                            "plural": true,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "values",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FilterValueType",
                                                    "plural": true,
                                                    "selections": (v27 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v59 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v28 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isVerifiedTrade",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "favorites",
                                            "storageKey": null,
                                            "args": [
                                                (v55 /*: any*/),
                                                {
                                                    "kind": "Variable",
                                                    "name": "pages",
                                                    "variableName": "followSearchPages"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "types",
                                                    "variableName": "followSearchTypes"
                                                }
                                            ],
                                            "concreteType": "favoritesConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "favoritesEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Favorite",
                                                            "plural": false,
                                                            "selections": (v33 /*: any*/)
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "recentHistoryList",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RecentHistoryItem",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "eventDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v32 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "firstPhotoWebPath",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "size",
                                                                    "value": "small"
                                                                }
                                                            ],
                                                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pdpURL",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v10 /*: any*/),
                                                        (v30 /*: any*/),
                                                        (v31 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v34 /*: any*/),
                                                        (v14 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canShowSellerName",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": "canShowInternalSellerName",
                                            "name": "hasPermission",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "name",
                                                    "value": "VIEW_SELLER_NAME"
                                                }
                                            ],
                                            "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "measurementUnit",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "verifiedTradeStatus",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v14 /*: any*/),
                                        {
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "condition": "isTrade",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "expiringPromotion",
                                                    "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"TRADESHIP\",\"RISKFREE\"])",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "daysToExpiration",
                                                            "value": 14
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "promoCodes",
                                                            "value": [
                                                                "TRADEWELCOME",
                                                                "TRADESHIP",
                                                                "RISKFREE"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "Promotion",
                                                    "plural": false,
                                                    "selections": [
                                                        (v60 /*: any*/),
                                                        (v6 /*: any*/),
                                                        (v14 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "tradeFirm",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TradeFirmType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v14 /*: any*/),
                                                        (v28 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "rewards",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TradeFirmRewards",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "educationMessagingSegments",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "RewardsMessagingSegment",
                                                                    "plural": true,
                                                                    "selections": (v61 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "pointsToMaintainStatus",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "pointsMessagingSegments",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "RewardsMessagingSegment",
                                                                    "plural": true,
                                                                    "selections": (v61 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "homepageMessagingSegments",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "RewardsMessagingSegment",
                                                                    "plural": true,
                                                                    "selections": (v61 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "postCheckoutMessagingSegments",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "RewardsMessagingSegment",
                                                                    "plural": true,
                                                                    "selections": (v61 /*: any*/)
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "tpnRole",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TradeFirmTPNRole",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "condition": "isTrade",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "loyalty",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmLoyaltyType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "currentYearSpend",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "FinancialAmount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v36 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "status",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "rewards",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmRewards",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "currentProgram",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ParentProgram",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "programInfo",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "LoyaltyProgram",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v6 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        (v57 /*: any*/),
                                                                                        (v14 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "nextProgram",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ParentProgram",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "programInfo",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "LoyaltyProgram",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        (v57 /*: any*/),
                                                                                        (v14 /*: any*/)
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "tradeFirmRewards",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TradeFirmRewards",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "currentPromoSegment",
                                                            "storageKey": null,
                                                            "args": (v59 /*: any*/),
                                                            "concreteType": "currentPromoSegmentType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "segmentCode",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "promotion",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Promotion",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "buyerExpirationDate",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v14 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "expiringPromoSegment",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "expiringPromoSegmentType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "expiringSegmentCode",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v60 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "sbRespRootQuery",
            "id": "app-buyer-finding/230.0.0-2019-08-29T07:47:30.905Z/sbRespRootQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'fa0f165db2b97c99435f65df078e92d5';
export default node;
